module.exports = __webpack_public_path__ + "static/img/logo3@2x.9b026a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo3@2x.png
// module id = 3rZd
// module chunks = 101